module.exports = __webpack_public_path__ + "static/img/12.f477aa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/12.png
// module id = N7+H
// module chunks = 0